import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { ToggleService } from '~/toggles/services/toggle.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Directive({
  selector: '[appIsEnabled]',
})
export class IsEnabledDirective {
  constructor(
    private readonly toggleService: ToggleService,
    private readonly templateRef: TemplateRef<Element>,
    private readonly viewContainer: ViewContainerRef
  ) {}

  @Input() set appIsEnabled(toggleName: ToggleNameEnum) {
    const isEnabled = this.toggleService.isEnabled(toggleName);
    if (isEnabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    this.viewContainer.clear();
  }
}
